$(document).ready(function() {

  document.querySelector("#modalLogIn")
    .addEventListener("hide.bs.modal", function () {
      $("#formLogin")[0].reset()
      delete $("#formLogin")[0].dataset.url
    })

  document.querySelector("#modalRegister")
    .addEventListener("hide.bs.modal", function () {
      $("#formRegistro")[0].reset()
      delete $("#formRegistro")[0].dataset.url
    })

  $(".btn-registro-login").click((e) => {
    e.preventDefault()
    $("#formRegistro")[0].dataset.url = $("#formLogin")[0].dataset.url
    $("#modalLogIn").modal("hide")
    $("#modalRegister").modal("show")
  })

  $(".btn-iniciar-registro").click((e) => {
    e.preventDefault()
    $("#formLogin")[0].dataset.url = $("#formRegistro")[0].dataset.url
    $("#modalRegister").modal("hide")
    $("#modalLogIn").modal("show")
  })

  $("#formLogin").validarForm((form) => {
    $("#btnLogin").loader("show")
    var formData = new FormData(form)
    axios
      .post("/iniciar-sesion", formData)
      .then((respuesta) => {
        $("#btnLogin").loader("hide")
        if (respuesta.data.error) {
          if(respuesta.data.reenviar_correo){
            swal({
              title: respuesta.data.error,
              icon: 'info',
              buttons: { cancel: 'Aceptar', ok: 'Reenviar correo', },
              dangerMode: true,
            }).then((ok) => {
              if (ok) {
                reenviarCorreoConfirmacion(formData)
              }
            });
          }
          else{
            swal({
              icon: "info",
              title: respuesta.data.error,
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          }
          return
        }
        let url = $("#formLogin")[0].dataset.url
        if(url != null && url != undefined && url != 'undefined'){
          location.href = url
        }
        else{
          location.reload()
        }
      })
      .catch((error) => {
        ReportErrorLog(error)
        console.error(error)
        $("#btnLogin").loader("hide")
        swal({
          icon: "info",
          title: "Ocurrió un error inesperado",
          button: {
            text: "Aceptar",
            closeModal: true,
          },
        })
      })
  })

  function reenviarCorreoConfirmacion(formData){
    $("#btnLogin").loader("show")
    axios
      .post("/registro-reenviar-correo", formData)
      .then((respuesta) => {
        $("#btnLogin").loader("hide")
        if (respuesta.data.error) {
          swal({
            icon: "info",
            title: respuesta.data.error,
            button: {
              text: "Aceptar",
              closeModal: true,
            },
          })
          return
        }
        swal({
          icon: "success",
          title: "Revisa tu correo para confirmar tu cuenta",
          button: {
            text: "Aceptar",
            closeModal: true,
          },
        })
      })
      .catch((error) => {
        ReportErrorLog(error)
        console.error(error)
        $("#btnLogin").loader("hide")
        swal({
          icon: "info",
          title: "Ocurrió un error inesperado",
          button: {
            text: "Aceptar",
            closeModal: true,
          },
        })
      })
  }

  document.querySelector("#modalRegister")
    .addEventListener("hide.bs.modal", function () {
      $("#formRegistro")[0].reset()
    })

  $("#formRegistro").validarForm((form) => {
    var formData = new FormData(form)
    if(formData.get("imagen").size == 0){
      swal({
        icon: "info",
        title: "Sube una foto",
        button: {
          text: "Aceptar",
          closeModal: true,
        },
      })
      return;
    }
    $("#btnRegistro").loader("show")
    axios
      .post("/registro", formData)
      .then((respuesta) => {
        $("#btnRegistro").loader("hide")
        if (respuesta.data.error) {
          swal({
            icon: "info",
            title: respuesta.data.error,
            button: {
              text: "Aceptar",
              closeModal: true,
            },
          })
          return
        }
        $("#modalRegister").modal("hide")
        swal({
          icon: "success",
          title: "Gracias por registrarte. Revisa tu correo para confirmar tu cuenta",
          button: {
            text: "Aceptar",
            closeModal: true,
          },
        })
        return;

        let url = $("#formRegistro")[0].dataset.url
        if(url != null && url != undefined && url != 'undefined') {
          location.href = url
        }
        else {
          location.reload()
        }
      })
      .catch((error) => {
        ReportErrorLog(error)
        console.error(error)
        $("#btnRegistro").loader("hide")
        swal({
          icon: "info",
          title: "Ocurrió un error inesperado",
          button: {
            text: "Aceptar",
            closeModal: true,
          },
        })
      })
  })
});
